import React, { useState } from "react";
import {
  AppBar,
  Toolbar,
  Container,
  Box,
  IconButton,
  Drawer,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Divider,
  TextField,
  Badge,
  MenuItem,
} from "@mui/material";
import { useAuth } from "../../context/AuthContext";

import { Person, Logout, Menu, ShoppingCart } from "@mui/icons-material";
import RegisterDialog from "../register";
import LoginDialog from "../login";
import colors from "../../config/colors";
import logo from "../../assets/logo.png";
import name from "../../assets/name.png";

const AppNavbar = ({
  cart,
  openCart,
  locationFilter,
  setLocationFilter,
  showLocationFilter,
}) => {
  const { logout } = useAuth();
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [loginOpen, setLoginOpen] = useState(false);
  const [registerOpen, setRegisterOpen] = useState(false);
  const totalItems = cart.reduce((sum, item) => sum + item.quantity, 0);

  const handleLogout = () => {
    logout();
    setDrawerOpen(false);
  };

  return (
    <>
      <AppBar
        position="fixed"
        sx={{
          width: "100%",
          top: 0,
          left: 0,
          backgroundColor: colors.light,
          zIndex: (theme) => theme.zIndex.drawer + 1,
        }}
      >
        <Container maxWidth={false}>
          <Toolbar
            disableGutters
            sx={{
              width: "100%",
              height: 90,
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            {/* LOGO */}

            <Box
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <img
                src={logo}
                alt="Logo"
                style={{
                  height: 70,
                }}
              />

              <img
                src={name}
                alt="Name"
                style={{
                  height: 35,
                  marginLeft: 15,
                }}
              />
            </Box>

            {/* DESKTOP */}

            <Box
              sx={{
                display: {
                  xs: "none",
                  md: "flex",
                },
              }}
            >
              {showLocationFilter && (
                <Box
                  sx={{
                    display: {
                      xs: "none",
                      md: "flex",
                    },

                    flex: 1,
                    justifyContent: "center",
                  }}
                >
                  <TextField
                    select
                    size="small"
                    label="Localização"
                    value={locationFilter}
                    onChange={(e) => setLocationFilter(e.target.value)}
                    sx={{
                      width: 220,
                      backgroundColor: "white",
                      borderRadius: 1,
                    }}
                  >
                    <MenuItem value="All">Todos os Locais</MenuItem>

                    <MenuItem value="Luanda">Luanda</MenuItem>

                    <MenuItem value="Lisboa">Lisboa</MenuItem>
                  </TextField>
                </Box>
              )}
              <IconButton onClick={() => setLoginOpen(true)}>
                <Person
                  fontSize="large"
                  sx={{
                    color: colors.primary,
                  }}
                />
              </IconButton>
              <IconButton onClick={handleLogout}>
                <Logout
                  fontSize="large"
                  sx={{
                    color: colors.primary,
                  }}
                />
              </IconButton>{" "}
              <IconButton onClick={openCart}>
                <Badge badgeContent={totalItems} color="error">
                  <ShoppingCart
                    sx={{ color: colors.primary }}
                    fontSize="large"
                  />
                </Badge>
              </IconButton>
            </Box>

            {/* MOBILE */}

            <Box
              sx={{
                display: {
                  xs: "flex",
                  md: "none",
                },
              }}
            >
              <IconButton onClick={() => setDrawerOpen(true)}>
                <Menu
                  fontSize="large"
                  sx={{
                    color: colors.primary,
                  }}
                />
              </IconButton>
            </Box>
          </Toolbar>
        </Container>
      </AppBar>
      {/* DRAWER MOBILE */}
      <Drawer
        anchor="right"
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
      >
        <Box
          sx={{
            width: 260,
            marginTop: 14,
          }}
        >
          <Divider />
          {showLocationFilter && (
            <Box
              sx={{
                p: 2,
              }}
            >
              <TextField
                select
                fullWidth
                size="small"
                label="Localização"
                value={locationFilter}
                onChange={(e) => setLocationFilter(e.target.value)}
              >
                <MenuItem value="All">Todos os Locais</MenuItem>

                <MenuItem value="Luanda">Luanda</MenuItem>

                <MenuItem value="Lisboa">Lisboa</MenuItem>
              </TextField>
            </Box>
          )}

          <List>
            <ListItemButton
              onClick={() => {
                setDrawerOpen(false);
                setLoginOpen(true);
              }}
            >
              <ListItemIcon>
                <Person
                  sx={{
                    color: colors.primary,
                  }}
                />
              </ListItemIcon>

              <ListItemText primary="Login" />
            </ListItemButton>

            <ListItemButton onClick={handleLogout}>
              <ListItemIcon>
                <Logout
                  sx={{
                    color: colors.primary,
                  }}
                />
              </ListItemIcon>

              <ListItemText primary="Logout" />
            </ListItemButton>

            <ListItemButton
              onClick={() => {
                setDrawerOpen(false);
                openCart();
              }}
            >
              <ListItemIcon>
                <Badge badgeContent={totalItems} color="error">
                  <ShoppingCart
                    sx={{
                      color: colors.primary,
                    }}
                  />
                </Badge>
              </ListItemIcon>

              <ListItemText primary="Cart" />
            </ListItemButton>
          </List>
        </Box>
      </Drawer>
      <LoginDialog
        open={loginOpen}
        onClose={() => setLoginOpen(false)}
        onRegister={() => {
          setLoginOpen(false);
          setRegisterOpen(true);
        }}
      />

      <RegisterDialog
        open={registerOpen}
        onClose={() => setRegisterOpen(false)}
        onLogin={() => {
          setRegisterOpen(false);
          setLoginOpen(true);
        }}
      />
    </>
  );
};

export default AppNavbar;
